/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { notification } from "./notification";
export function isSelectorValid(selector) {
  function queryCheck(s) {
    document.createDocumentFragment().querySelector(s);
  }
  try {
    queryCheck(selector);
  } catch (_unused) {
    return false;
  }
  return true;
}
export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
export function tooltip(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var config = {
    trigger: 'hover'
  };
  var tooltipElements = container.querySelectorAll("[data-bs-toggle=\"tooltip\"]");
  for (var i = 0; i < tooltipElements.length; i++) {
    if (tooltipElements[i].dataset.bsTrigger) {
      config.trigger = tooltipElements[i].dataset.bsTrigger;
    }
    new bootstrap.Tooltip(tooltipElements[i], config);
  }
}
export function scrollTo(pos, time) {
  if (time === void 0) {
    time = 500;
  }
  // find scrollToSmoothly and replace
  var currentPos = window.pageYOffset;
  var start = null;
  pos = +pos;
  time = +time;
  window.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start;
    var progress = currentTime - start;
    if (currentPos < pos) {
      window.scrollTo(0, (pos - currentPos) * progress / time + currentPos);
    } else {
      window.scrollTo(0, currentPos - (currentPos - pos) * progress / time);
    }
    if (progress < time) {
      window.requestAnimationFrame(step);
    } else {
      window.scrollTo(0, pos);
    }
  });
}
export function getOffsetTop(element) {
  var offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}
export function getNextSibling(elem, selector) {
  // Get the next sibling element
  var sibling = elem.nextElementSibling;
  // If there's no selector, return the first sibling
  if (!selector) return sibling;
  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling;
  }
}
export function copyToClipboard(text) {
  // Clipboard API not available
  if (!navigator.clipboard) return console.error('Clipboard API not available');

  // const cb = navigator.clipboard;
  try {
    navigator.clipboard.writeText(text).then(function () {
      notification('success', 'Copied', 1000);
    });
  } catch (err) {
    console.error('Failed to copy!', err);
  }
  // return cb.writeText(text).then(() => graviton_app.notification('success', 'Copied', 2000));
}

export function slugify(text, separator) {
  text = text.toString().toLowerCase().trim();
  var sets = [{
    to: "a",
    from: "[ÀÁÂÃÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶΑΆА]"
  }, {
    to: "b",
    from: "[ΒБ]"
  }, {
    to: "ae",
    from: "[Ä]"
  }, {
    to: "c",
    from: "[ÇĆĈČ]"
  }, {
    to: "ch",
    from: "[Ч]"
  }, {
    to: "d",
    from: "[ÐĎĐÞΔД]"
  }, {
    to: "e",
    from: "[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆΕΈЕЭ]"
  }, {
    to: "f",
    from: "[ΦФ]"
  }, {
    to: "g",
    from: "[ĜĞĢǴΓГ]"
  }, {
    to: "h",
    from: "[ĤḦ]"
  }, {
    to: "i",
    from: "[ÌÍÎÏĨĪĮİỈỊΗΉΙΊΪΐИ]"
  }, {
    to: "j",
    from: "[Ĵ]"
  }, {
    to: "ij",
    from: "[Ĳ]"
  }, {
    to: "iy",
    from: "[ЫЙ]"
  }, {
    to: "k",
    from: "[ĶΚК]"
  }, {
    to: "kh",
    from: "[Х]"
  }, {
    to: "ks",
    from: "[Ξ]"
  }, {
    to: "l",
    from: "[ĹĻĽŁΛЛ]"
  }, {
    to: "m",
    from: "[ḾΜМ]"
  }, {
    to: "n",
    from: "[ÑŃŅŇΝН]"
  }, {
    to: "o",
    from: "[ÒÓÔÕØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠΟΌΩΏО]"
  }, {
    to: "oe",
    from: "[ŒÖ]"
  }, {
    to: "p",
    from: "[ṕΠП]"
  }, {
    to: "ps",
    from: "[Ψ]"
  }, {
    to: "r",
    from: "[ŔŖŘΡР]"
  }, {
    to: "s",
    from: "[ŚŜŞŠΣςС]"
  }, {
    to: "sh",
    from: "[Ш]"
  }, {
    to: "sch",
    from: "[Щ]"
  }, {
    to: "ss",
    from: "[ß]"
  }, {
    to: "t",
    from: "[ŢŤΤТ]"
  }, {
    to: "th",
    from: "[Θ]"
  }, {
    to: "ts",
    from: "[Ц]"
  }, {
    to: "u",
    from: "[ÙÚÛŨŪŬŮŰŲỤỦỨỪỬỮỰƯΥΎΫΰУ]"
  }, {
    to: "ue",
    from: "[Ü]"
  }, {
    to: "v",
    from: "[В]"
  }, {
    to: "w",
    from: "[ẂŴẀẄ]"
  }, {
    to: "x",
    from: "[ẍΧ]"
  }, {
    to: "y",
    from: "[ÝŶŸỲỴỶỸЙЫ]"
  }, {
    to: "ya",
    from: "[Я]"
  }, {
    to: "ye",
    from: "[ЪЕ]"
  }, {
    to: "yo",
    from: "[Ё]"
  }, {
    to: "yu",
    from: "[Ю]"
  }, {
    to: "z",
    from: "[ŹŻŽΖЗ]"
  }, {
    to: "zh",
    from: "[Ж]"
  }, {
    to: "-",
    from: "[·/_,:;']"
  }];
  sets.forEach(function (set) {
    text = text.replace(new RegExp(set.from, "gi"), set.to);
  });
  text = text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
  .replace(/&/g, "-and-") // Replace & with 'and'
  // .replace(/[^\w\-]+/g, "") // Remove all non-word chars
  .replace(/[^a-zA-Z0-9_\u3400-\u9FBF\s-]/g, '') // Remove all non-word chars [Chinese]
  .replace(/\--+/g, "-") // Replace multiple - with single -
  .replace(/^-+/, "") // Trim - from start of text
  .replace(/-+$/, ""); // Trim - from end of text

  if (typeof separator !== "undefined" && separator !== "-") {
    text = text.replace(/-/g, separator);
  }
  return text;
}
export function setInputFocus(input) {
  input.focus();
  console.info(input);
  input.setSelectionRange(input.value.length, input.value.length, "forward");
}
export function getLatinKey(key, code) {
  if (key.length !== 1) {
    return key;
  }
  var capitalHetaCode = 880;
  var isNonLatin = key.charCodeAt(0) >= capitalHetaCode;
  if (isNonLatin) {
    if (code.indexOf('Key') === 0 && code.length === 4) {
      // i.e. 'KeyW'
      return code.charAt(3);
    }
    if (code.indexOf('Digit') === 0 && code.length === 6) {
      // i.e. 'Digit7'
      return code.charAt(5);
    }
  }
  return key.toUpperCase();
}
export function getAllUncheckedCheckboxes(form) {
  var array = [];
  if (!form) return array;
  var checkboxes = form.querySelectorAll('input[type="checkbox"]:not(.ns)'); // ns - not send
  for (var i = 0; i < checkboxes.length; i++) {
    if (!checkboxes[i].checked) {
      array.push(checkboxes[i].name);
    }
  }
  return array;
}

// Alternative

// function scrollG(anchor, duration) {
//
//
// 	// Calculate how far and how fast to scroll
// 	var startLocation = window.pageYOffset;
// 	var endLocation = anchor.offsetTop;
// 	var distance = endLocation - startLocation;
// 	var increments = distance / (duration / 16);
// 	var stopAnimation;
//
// 	// Scroll the page by an increment, and check if it's time to stop
// 	var animateScroll = function () {
// 		window.scrollBy(0, increments);
// 		stopAnimation();
// 	};
//
// 	// If scrolling down
// 	if (increments >= 0) {
// 		// Stop animation when you reach the anchor OR the bottom of the page
// 		stopAnimation = function () {
// 			var travelled = window.pageYOffset;
// 			if ((travelled >= (endLocation - increments)) || ((window.innerHeight + travelled) >= document.body.offsetHeight)) {
// 				clearInterval(runAnimation);
// 			}
// 		};
// 	}
// 	// If scrolling up
// 	else {
// 		// Stop animation when you reach the anchor OR the top of the page
// 		stopAnimation = function () {
// 			var travelled = window.pageYOffset;
// 			if (travelled <= (endLocation || 0)) {
// 				clearInterval(runAnimation);
// 			}
// 		};
// 	}
//
// 	// Loop the animation function
// 	var runAnimation = setInterval(animateScroll, 16);
//
//
// }